import api from './api';

const BASE = '/natcash';

export default {
  list: (params = {}) =>
    api.get(BASE, { params: { functionCode: 'NATCASH_VIEW', ...params } }).then(r => r.data),

  operators: () =>
    api.get(`${BASE}/operators`, { params: { functionCode: 'NATCASH_VIEW' } }).then(r => r.data),

  get: (id) =>
    api.get(`${BASE}/${id}`, { params: { functionCode: 'NATCASH_VIEW' } }).then(r => r.data),

  create: (data) =>
    api.post(BASE, { ...data, functionCode: 'NATCASH_CREATE' }).then(r => r.data),

  update: (id, data) =>
    api.put(`${BASE}/${id}`, { ...data, functionCode: 'NATCASH_UPDATE' }).then(r => r.data),

  remove: (id) =>
    api.delete(`${BASE}/${id}`, { data: { functionCode: 'NATCASH_DELETE' } }).then(r => r.data),
};
